import PropTypes from 'prop-types'
import styled from 'styled-components'

const Hero = (props) => {
  const { children, className, maxWidth, align, padding } = props

  return (
    <HeroBase className={className} align={align} padding={padding}>
      {maxWidth ?
        (
          <Inner maxWidth={maxWidth}>
            {children}
          </Inner>
        ) :
        (children)
      }
    </HeroBase>
  )
}

const HeroBase = styled.section`
  align-items: center;
  flex-direction: column;
  justify-content: center;
  display: flex;
  padding: ${ ({ padding }) => padding };
  text-align: ${ ({ align }) => align };
  background-color: ${ ({ theme }) => theme.colors.cream };
  
  h1{
    margin: 0;
  }
`

const Inner = styled.div`
  width: 100%;
  max-width: ${ ({ maxWidth }) => maxWidth };
`

Hero.defaultProps = {
  className: '',
  maxWidth: null,
  align: 'center',
  padding: '100px 20px',
}

Hero.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]).isRequired,
  className: PropTypes.string,
  maxWidth: PropTypes.string,
  align: PropTypes.string,
  padding: PropTypes.string,
}

export default Hero
